'use client';

import type { ReactElement, ReactNode } from 'react';
import { ModalLocation } from '@/constants/componentPresets';
import { Cmodal } from '../Cmodal';

interface CenterModalProps {
  content?: ReactNode;
  location?: ModalLocation;
  onClose: () => void;
  useContainerBackground: boolean;
  visible?: boolean;
}

export function CenterModal({
  content,
  location,
  onClose,
  useContainerBackground,
  visible,
}: CenterModalProps): ReactElement {
  return (
    <Cmodal
      dataElScope="Cpagelayout/CenterModal"
      visible={visible ?? false}
      location={location ?? ModalLocation.Center}
      content={content}
      useContainerBackground={useContainerBackground}
      onClose={onClose}
    />
  );
}
